










































































































import { Component, Prop } from 'vue-property-decorator';
import { SwIcon, IconConfig } from '../sw-icon';
import { SwExtendedVue } from '../sw-extended-vue';
import { utilService } from '../util-service';

const cssPrefix: string = 'sw-circular-button';

/**
 * @event mouseenter
 * @event mouseleave
 * @event mousedown
 * @event mouseup
 * @event click
 * @event mouseout
 * @event mouseover
 */
@Component({
  components: {
    SwIcon,
  },
})
export default class SwCircularButton extends SwExtendedVue {
  cssPrefix: string = cssPrefix;

  @Prop({ type: String, default: 'default' })
  textPosition: 'default' | 'right';

  @Prop({ type: [String, Object], required: true })
  icon: string | IconConfig;

  @Prop({ type: String, default: utilService.colorConst.selected })
  buttonColor: string;

  @Prop({ type: Boolean, default: false })
  noBorder: boolean;

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: Boolean, default: false })
  breakWord: boolean;

  get effectiveButtonIcon(): IconConfig {
    return Object.assign(
      { size: 20 },
      typeof this.icon === 'string' ? { name: this.icon } : this.icon,
    );
  }

  get effectiveTextPosition(): string {
    return this.textPosition === 'right' ? 'row' : 'column';
  }

  private hasText() {
    const slot = utilService.getVueScopedSlot(this.$scopedSlots);
    return slot.length > 0;
  }

  private onMouseEnter(event: MouseEvent) {
    this.$emit('mouseenter', event);
  }

  private onMouseLeave(event: MouseEvent) {
    this.$emit('mouseleave', event);
  }

  private onMouseDown(event: MouseEvent) {
    this.$emit('mousedown', event);
  }

  private onMouseUp(event: MouseEvent) {
    this.$emit('mouseup', event);
  }

  private onMouseWheel(event: MouseEvent) {
    this.$emit('mousewheel', event);
  }

  private onClick(event: MouseEvent) {
    this.$emit('click', event);
  }

  private onMouseOut(event: MouseEvent) {
    this.$emit('mouseout', event);
  }

  private onMouseOver(event: MouseEvent) {
    this.$emit('mouseover', event);
  }
}
